import styled from '@emotion/styled';

export const Container = styled.div`
	width: 100%;
	background-color: var(--background-3);
	border-radius: 48px;
	transition: all 0.2s ease;

	.small {
		height: 0.22rem;
	}
	.medium {
		height: 0.43rem;
	}
	.large {
		height: 0.65rem;
	}
`;

export const Filler = styled.div`
	min-height: 100%;
	background: ${({ value, color, successColor }) =>
		value === 100 ? (successColor ? successColor : 'var(--blue)') : color ? color : 'var(--blue)'};
	border-radius: inherit;
	text-align: right;
	animation: animate 1s ease;
	width: ${(props) => props.value}%;
	position: relative;
	@keyframes animate {
		0% {
			width: 0;
		}
		100% {
			width: ${(props) => props.value}% !important;
		}
	}

	.percentage {
		position: absolute;
		bottom: 0.5rem;
		right: 0;
		left: 0;
		overflow: unset;
	}
`;

export const ProgressCircle = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;

	.percentage {
		position: absolute;
	}

	.text-small {
		font-size: 0.8rem;
	}

	.text-medium {
		font-size: var(--caption-font-size);
	}

	.small {
		width: 3.5rem;
		height: 3.5rem;
	}
	.medium {
		width: 5.5rem;
		height: 5.5rem;
	}
`;

export const SvgContainer = styled.svg`
	width: 3.5rem;
	height: 3.5rem;
`;

export const Circle = styled.circle`
	fill: none;
	stroke-width: 10;
	stroke-linecap: round;
	transform: rotate(-90deg);
	transform-origin: 50% 50%;
	stroke: ${({ color }) => color};
	stroke-dasharray: 314;
	stroke-dashoffset: ${({ value = 0 }) => 314 - (314 * value) / 100};
	transition: stroke-dashoffset 0.3s ease;
`;
